<template>
  <CustomerShow v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

import CustomerShow from "@/Customer/Profile/CustomerShow.vue";

interface Filter {
  type: string;
  name: string;
  value: string;
}

const route = useRoute();
const initialData = ref<{
  customerId: number;
  invoiceDatatableSource: string;
  quoteDatatableSource: string;
  quoteFilters: Filter[];
  appointmentsDatatableSource: string;
  appointmentFilters: Filter[];
  subCustomersDatatableSource: string;
  subCustomerFilters: Filter[];
  invoiceFilters: Filter[];
  phoneCallFilters: Filter[];
  communicationSettingsPath: string;
  communicationsChangeHistoryPath: string;
} | null>(null);

onMounted(async () => {
  // Load initial page data and send to component as props
  const data = await fetch(`/customers/${route.params.id}/initial_page_data`, {
    method: "GET"
  }).then((res) => res.json());
  initialData.value = data;
});
</script>

<style scoped></style>
